import { request } from './request'

/**
 * 首页及公共接口
 */
export const homeApi = {
  /** 获取首页基本信息 */
  getHomeInfo() {
    return request('/api/index/home', {
      method: 'POST',
      formData: true
    })
  },

  /** 系统公告 */
  getNotice() {
    return request('/api/index/notice', {
      method: 'POST',
      formData: true
    })
  },

  /** 获取商品分类（商品列表的导航栏目） */
  getCategories() {
    return request('/api/index/getcate', {
      method: 'POST',
      formData: true
    })
  },

  /** 获取商品品牌 */
  getBrands(data) {
    return request('/api/index/getbrand', {
      method: 'POST',
      formData: true,
      body: data
    })
  },

  /** 获取品型 */
  getPinxing() {
    return request('/api/index/getpinxing', {
      method: 'POST',
      formData: true
    })
  },

  /** 资讯列表 */
  getNewsList(data) {
    return request('/api/index/newslist', {
      method: 'POST',
      formData: true,
      body: data
    })
  },

  /** 资讯详情 */
  getNewsInfo(data) {
    return request('/api/index/newsinfo', {
      method: 'POST',
      formData: true,
      body: data
    })
  },

  /** 得到联系我们数据 */
  getContact() {
    return request('/api/index/getcontact', {
      method: 'POST',
      formData: true
    })
  },

  /** 获取单页内容（关于我们、使用条款、隐私政策等） */
  getPage() {
    return request('/api/index/getpage', {
      method: 'POST',
      formData: true
    })
  },

  /** 提交留言/联系我们表单 */
  addMessage(data) {
    return request('/api/index/message', {
      method: 'POST',
      formData: true,
      body: data
    })
  },

  /** 获取积分规则、会员等级说明 */
  getGuize() {
    return request('/api/index/guize', {
      method: 'POST',
      formData: true
    })
  }
}
